import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"

interface ISuccessDialogProps {
  open: boolean
  onCloseClick: () => void
  setOpen?: (value: ((prevState: boolean) => boolean) | boolean) => void
  successMessage?: string
}

export default function SuccessDialog({
  open,
  setOpen,
  onCloseClick,
  successMessage,
}: ISuccessDialogProps) {
  const handleClose = () => {
    setOpen?.(false)
    onCloseClick()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Success"}</DialogTitle>
      <DialogContent sx={{ minWidth: 400 }}>
        <DialogContentText id="alert-dialog-description">
          {successMessage || "Form saved successfully"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseClick} color={"error"} autoFocus={true} variant={"contained"}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}
